// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__BVHzB","crumb":"Breadcrumbs_crumb__hC29s","angle":"Breadcrumbs_angle__8VbWG","mobile":"Breadcrumbs_mobile__l08v1"};